export const residents = {
  david: {
    name: 'David',
    photo: './photo/Davyd.png',
    subTitle: false,
    text1: `Dark prince of the crew. Hypnotic mesmerizing jams shift to dense
    assertiveness edging on vibrant and sometimes even gloomy tension in
    his sets. With a background as a singer-songwriter, David has always
    had a rather distinct artistic approach that works unpredictably
    charmingly when it comes to playing in public.`,
    text2: `Besides being a co-host of Morning Show and part-time djing tutor,
    David ran his own series 'Magic Pills' through which he delivered
    elegant and magnetic leftfield downtempo electronics.`,
    style: {
      top: '45%',
      left: '23%',
    },
    mix: (
      <iframe
        title="daveMix"
        width="100%"
        height="146"
        scrolling="no"
        frameborder="no"
        allow="autoplay"
        src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/693723724&color=%234c5c4c&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"
      ></iframe>
    ),
  },
  misha: {
    name: 'Misha',
    photo: './photo/Misha.png',
    subTitle: false,
    subTitleText: '(from the Radio)',
    text1: `Kyiv-based slacker Misha started djing in 2017 on Amsterdam’s Red
    Light Radio with his show ‘Where on Earth’, dedicated to Ukraine's
    underground and naive music. After the 20ft Radio launch, he became a
    co-host of Morning Show with David Shamiev and started djing at
    parties.`,
    text2: `His kaleidoscopic and intuitive style brings the attentiveness of a
    listening session to the dancefloor, without losing party’s groove and
    fun. Working with mood rather than music styles, his musical jokes and
    unpredictable turns of storytelling keeps the audience in a trippy
    mood, leaving no chance to cling to something.`,
    style: { top: '20%', left: '2%' },
    mix: (
      <iframe
        title="misha_mix"
        width="100%"
        height="146"
        scrolling="no"
        frameborder="no"
        allow="autoplay"
        src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/803794348&color=%233d321d&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"
      ></iframe>
    ),
  },
  nemo: {
    name: 'Nemo Jr.',
    photo: './photo/Nemo_Jr.png',
    subTitle: false,
    text1: `Interstellar overdrive captain who’s capable of leading the dancefloor
    from humid and bouncy dubbing gradually into a psychedelic cosmic
    disco-house whirlwind full of weird shifting moods. Kicks in pretty
    strongly, especially for the unprepared public.`,
    text2: ` Being a long-time resident of 20ft Radio, Nemo has contributed to it
    in various forms: as a part of the team and as an author of several
    thematic series like Alienation or Anadolu Invasion. Recently he moved
    to the Netherlands where he started his monthly lo-fi music show
    ‘Boredom Kingdom’ on Rotterdam’s Operator Radio.`,
    style: { top: '30%', left: '51%' },
    mix: (
      <iframe
        title="nemo_mix"
        width="100%"
        height="146"
        scrolling="no"
        frameborder="no"
        allow="autoplay"
        src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1313545357&color=%233d321d&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"
      ></iframe>
    ),
  },
  junkoid: {
    name: 'Anthony Junkoid',
    photo: './photo/Junkoid.png',
    subTitle: false,
    text1: `Mastermind behind the Unaussprechlichen Kulten show on 20ft Radio, where providing endless pilgrimage to other side of the music ark since 2017 and a contributor in such radio shows as Lovely Songs For Lovers, Alienation, Healing Hour. `,
    text2: `Anthony's selections are performed as cross-genre audio narratives, where obscure experimentalism replaces hidden sentiment, and subterranean acoustics sounds like an ethereal call. Filled with rarities and unexpected finds, his mixes catch that invisible wonderful musical moment when bestial comes celestial!
    `,
    style: { top: '50%', left: '73%' },
    mix: (
      <iframe
        title="junkoidMix"
        width="100%"
        height="146"
        scrolling="no"
        frameborder="no"
        allow="autoplay"
        src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1415732653&color=%234c5c4c&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"
      ></iframe>
    ),
  },
};
